import { ProducerData } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { Submission } from '../service/Policy.service.type';
import { ProducerDataTrackingCodes } from './trackingCodes';

const DEFAULT_SALES_CHANNEL = 'web';
const SECOND_UTM_AFFILIATE_LINK_VERSION = '2';

export const getSubmissionWithProducerData = (
  submission: Submission,
  { utmAffLinkVersion, employeeId, salesChannel }: ProducerDataTrackingCodes | undefined = {},
): Submission => ({
  ...submission,
  baseData: {
    ...submission.baseData,
    ...(utmAffLinkVersion === SECOND_UTM_AFFILIATE_LINK_VERSION && employeeId && {
      producerData: {
        producerUtmID: employeeId,
        salesChannel: salesChannel as ProducerData['salesChannel'] ?? DEFAULT_SALES_CHANNEL,
      },
    }),
  },
});
